import { usePhoneButton } from "../../InformationRequest/LeadButtons/PhoneButton/hook";
import { MouseEvent, useState, FC, useContext, useEffect } from "react";
import { Button, Card, Col, Row, Space } from "antd";
import Text from "antd/lib/typography/Text";
import Paragraph from "antd/lib/typography/Paragraph";
import { ModalPhone } from "../../ModalPhone/web";
import "./styles.less";
import { useFacebookPixel } from "../../../../GlobalHooks/web/FacebookPixel.hook";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { UserStateContext } from "shared-components/Contexts/User/context";
import dynamic from "next/dynamic";
import Mandatory from "shared-components/Components/User/Mandatory/web";
import { useUser } from "shared-components/Components/User/User.hook";
const Modal = dynamic(() => import("shared-components/Components/Modal/web").then(mod => mod.Modal), { ssr: false });

interface SubsidiaryProps {
	id: string;
	propertyId: string;
	mode: string;
	name: string;
	address: string;
	officeHours: string;
	maskedPhone: string;
	disabled?: boolean;
	isProject?: boolean;
}

export const Subsidiary: FC<SubsidiaryProps> = ({
	id,
	propertyId,
	mode,
	name,
	address,
	officeHours,
	maskedPhone,
	disabled = false,
	isProject
}) => {
	const { viewPhone, phone, loading } = usePhoneButton({ property_id: propertyId, isProject });
	const { country_code } = useContext(ConfigStateContext);

	const FP = useFacebookPixel();
	const [modal, setModal] = useState(false);
	const [phoneData, setPhoneData] = useState(null);

	const makePhoneCall = (phoneNumber) => {
        if (phoneNumber) {
            window.location.href = `tel:${phoneNumber}`;
            return true;
        }
        return false;
    };

	const handleClick =async (e: MouseEvent) => {
		e.preventDefault();
        e.stopPropagation();

        if (phoneData) {
            makePhoneCall(phoneData.data.requestPhoneAgent[0].phone)
            setModal(true);
        } else {
            await viewPhone().then(data => {
                if (data) {
                    makePhoneCall(data.data.requestPhoneAgent[0].phone);
                    setPhoneData(data);
                    setModal(true);
                }
            });
        }
	};

	const sendEvent = () => {
		const categoryName: string = "Consultas Tel";

		FP.StandardEvent(categoryName);
	};
	const { isLoggedIn, user: { refetch } } = useUser();
	const [userHasAllData, setUserHasAllData] = useState(false);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const user = useContext(UserStateContext);

	useEffect(() => {
		if (country_code !== "CO") {
			setUserHasAllData(true);
		}
		if (country_code === "CO" && user.me) {
			const hasAllData = !!user.me.phone && !!user.me.name;
			setUserHasAllData(hasAllData);
		}
	}, [user.me]);


	return (
		<>
			<Modal
				show={isModalVisible}
				onClose={() => setIsModalVisible(false)}
				height="500px"
			>
				<div className="auth-modal-wrapper">
					<div className="auth-modal">
						<Mandatory
							onOk={(e: any) => {
								handleClick(e);
								setIsModalVisible(false);
								setUserHasAllData(true);
								refetch();
							}}
							user={user}
						/>
					</div>
				</div>
			</Modal>

			<Card key={id} size={"small"} className="subsidiary">
				<Row gutter={16} align={"middle"}>
					{country_code !== "CO" && <Col flex={1} className="center">
						<Text strong className="title">
							{name}
						</Text>
						<Paragraph
							className="paragraph"
							ellipsis={country_code === "ce3" ? false : { rows: 1, expandable: false, symbol: "Más" }}>
							{address}
						</Paragraph>
						<Text type={"secondary"} className={"hours"}>
							{officeHours}
						</Text>
					</Col>}
					<Col style={{ margin: "auto" }}>
						{country_code !== "BR" && (
							<Space size={4} >
								<Text className="masked">{maskedPhone}</Text>
								<Button
									loading={loading}
									onClick={(e: any) => {
										if (userHasAllData || !isLoggedIn) {
											handleClick(e)
										} else {
											setIsModalVisible(true);
										}
									}}
									className="secondary"
									disabled={disabled}>
									{"Ver teléfono"}
								</Button>
							</Space>
						)}
					</Col>
				</Row>

				<ModalPhone
					mode={mode}
					phone={phone}
					owner_name={name}
					property_id={propertyId}
					loading={loading}
					visible={modal}
					onCancel={() => setModal(false)}
				/>
			</Card>
		</>
	);
};
